import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebook,
  faTiktok,
  faBluesky,
  faInstagram,
  faThreads,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import { faHeart as faHeartReg } from "@fortawesome/free-regular-svg-icons";
import {
  faUpload,
  faDownload,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faDatabase,
  faDashboard,
  faSquarePlus,
  faGripVertical,
  faGear,
  faFlask,
  faHeart,
  faMap,
  faInfo,
  faInfoCircle,
  faPencil,
  faLocationArrow,
  faExternalLink,
  faTimes,
  faTrash,
  faX,
  faTasks,
  faHandPaper,
  faAddressBook,
  faDonate,
  faIdCard,
  faMapMarkerAlt,
  faLocationCrosshairs,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
  library.add(
    faUpload,
    faDownload,
    faAngleDown,
    faAngleUp,
    faAngleRight,
    faFacebook,
    faTiktok,
    faBluesky,
    faInstagram,
    faThreads,
    faDatabase,
    faDashboard,
    faSquarePlus,
    faGripVertical,
    faGear,
    faFlask,
    faHeart,
    faMap,
    faInfo,
    faInfoCircle,
    faPencil,
    faLocationArrow,
    faExternalLink,
    faTimes,
    faTrash,
    faX,
    faGoogle,
    faHeartReg,
    faTasks,
    faHandPaper,
    faAddressBook,
    faDonate,
    faIdCard,
    faMapMarkerAlt,
    faLocationCrosshairs,
    faSpinner,
  );
}

export { FontAwesomeIcon, initFontAwesome };
